import BlueDotsBackground from '../BlueDotsBackground';

/**
 * Shared building blocks for the authentication screens so every step
 * (sign in, set password, MFA) shares one cohesive, elegant look that
 * matches the rest of the app's dark, blue-accented design.
 */

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <>
      <BlueDotsBackground />
      <div className="min-h-screen text-white flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-8">
            <img
              src="/kernelDark.png"
              alt="Kernel"
              className="h-9 w-auto opacity-90"
            />
          </div>
          <div className="bg-gray-800/80 backdrop-blur-sm border border-gray-700 p-8 rounded-2xl shadow-xl">
            <h2 className="text-2xl font-semibold text-center">{title}</h2>
            {subtitle && (
              <p className="text-sm text-gray-400 mt-2 mb-6 text-center leading-relaxed">
                {subtitle}
              </p>
            )}
            <div className={subtitle ? '' : 'mt-6'}>{children}</div>
          </div>
          {footer && (
            <p className="text-sm text-center text-gray-400 mt-6">{footer}</p>
          )}
        </div>
      </div>
    </>
  );
}

export function AuthField({ label, hint, ...props }) {
  return (
    <div>
      <label className="block text-sm mb-2 text-gray-200">{label}</label>
      <input
        className="w-full px-4 py-3 bg-gray-700/70 border border-gray-600 rounded-xl placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
        {...props}
      />
      {hint && <p className="text-xs text-gray-500 mt-1.5">{hint}</p>}
    </div>
  );
}

export function SubmitButton({ busy, busyLabel, children, ...props }) {
  return (
    <button
      type="submit"
      disabled={busy}
      className="w-full bg-blue-600 hover:bg-blue-700 py-3 rounded-xl font-medium transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
      {...props}
    >
      {busy ? (busyLabel ?? 'Please wait…') : children}
    </button>
  );
}

export function TextButton({ children, ...props }) {
  return (
    <button
      type="button"
      className="text-sm text-blue-400 hover:underline"
      {...props}
    >
      {children}
    </button>
  );
}

export function FormError({ children }) {
  if (!children) return null;
  return <p className="text-sm text-center text-red-400 mt-4">{children}</p>;
}

export function FormNotice({ children }) {
  if (!children) return null;
  return (
    <p className="text-sm text-center text-emerald-400 mt-4">{children}</p>
  );
}
